import clsx from 'clsx';

export type SpinnerProps = {
  isCentered?: boolean;
  isDark?: boolean;
  isLarge?: boolean;
  testId?: string;
  classNames?: string;
};

export const Spinner = ({
  isCentered = true,
  isDark,
  isLarge,
  testId,
  classNames,
}: SpinnerProps) => (
  <i
    className={clsx(
      'amplify-spinner',
      {
        'spinner-centered': isCentered,
        'spinner-dark': isDark,
        'spinner-large': isLarge,
      },
      classNames,
    )}
    role="status"
    data-testid={testId}
  >
    <div className="loader" />
  </i>
);
